import { UrlSlugsUtil } from '@axiom/utils';
import type {
  Account,
  Candidate,
  Opportunity,
  Taxonomy,
} from '@axiom/validation';
import qs from 'qs';

import { EnvUtil } from './env-util';

const getShareUrl = (
  candidate: Pick<
    Candidate,
    | 'calculatedDisplayName'
    | 'primaryPracticeArea'
    | 'primaryFocusArea'
    | 'publicRefId'
  >,
  taxonomy: Taxonomy
): string =>
  `/browse-talent/${UrlSlugsUtil.generateCandidateSlug(candidate, taxonomy)}`;

const getSharePath = (
  candidate: Pick<
    Candidate,
    | 'calculatedDisplayName'
    | 'primaryPracticeArea'
    | 'primaryFocusArea'
    | 'publicRefId'
  >,
  taxonomy: Taxonomy
): string => {
  const {
    location: { pathname, search },
  } = window;
  const queryParams = {
    page: pathname ? pathname.split('/').at(-1) : undefined,
    ...qs.parse(search, { ignoreQueryPrefix: true }),
  };
  return `/browse-talent/${UrlSlugsUtil.generateCandidateSlug(
    candidate,
    taxonomy
  )}${qs.stringify(queryParams, { addQueryPrefix: true })}`;
};

const generateClientProjectsUrl = (account: Pick<Account, 'id'>) =>
  `/account/${account.id}`;

const generateAHQOpportunityURL = (opportunity: Pick<Opportunity, 'id'>) =>
  `${EnvUtil.envoyUrl}/opportunity-detail/${opportunity.id}`;

export const LinkUtil = {
  getShareUrl,
  getSharePath,
  generateClientProjectsUrl,
  generateAHQOpportunityURL,
};
